/**
 *
 * @module thumbnailResolution
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ThumbnailResolution
 * @type {Object}
 * @since 3.8.0
 * @desc Defines the possible thumbnail resolutions available
 * @example ThumbnailResolution.low // 'low'
 *
 * @property {String} low - Supplies "low" as the resolution parameter to MediaManager
 * @property {String} medium - Supplies "medium" as the resolution parameter to MediaManager
 * @property {String} high - Supplies "high" as the resolution parameter to MediaManager
 *
 */

/**
 *
 * @enum
 * @type {ThumbnailResolution}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    low: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    medium: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    high: null
});



// WEBPACK FOOTER //
// ./src/media/thumbnailResolution.js